module.exports = "<div class=\"section-resources\">\n    <div class=\"section-resources__title\">Further Guidance</div>\n    <ul class=\"list list--resources\">\n        <li><a href=\"#\">Homeowner Repair or Rehabilitation</a></li>\n        <li><a href=\"#\">Preservation of Mobile Homes(Rent Stabilization Ordinance)</a></li>\n        <li><a href=\"#\">Inclusionary Housing Ordinance</a></li>\n        <li><a href=\"#\">Housing Overlay Zone</a></li>\n    </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/directives/furtherguidance/furtherguidance.html
// module id = 66
// module chunks = 0